module.exports = __webpack_public_path__ + "img/ls.0070f48b.jpg";